export default __webpack_public_path__ + "108754d4e1e39b2e374019ca97a8dcee.png";